import {
  CheckboxGroupButtons,
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  RangePicker,
} from '@/components/_common';
import { Col, Form, FormInstance, Row, Select } from 'antd';
import moment from 'moment';
import { workOrderCalendarDateTypeLabels } from '@/core/domain/workorder/WorkOrders/WorkOrders.constants';
import { WorkOrderCalendarDateType } from '@/core/domain/workorder/WorkOrders/WorkOrders.enum';
import { ManagerialAuditFormValues } from '@/pages/Reports/ManagerialReportsPage/ManagerialAuditPage';
import {
  workorderComplementLabel,
  WorkOrderComplementStatus,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useEffect } from 'react';
import {
  WorkOrderAuditItemTypes,
  WorkOrderAuditSituationType,
} from '@/core/domain/workorder/AuditData/AuditData.enums';
import { workOrderAuditSituationLabels } from '@/core/domain/workorder/AuditData/AuditData.constants';
interface Props {
  form: FormInstance<ManagerialAuditFormValues>;
}

export default function ManagerialAuditForm({ form }: Props) {
  const situationType = Form.useWatch('situationType', form);
  const workOrderStatus = Form.useWatch('workOrderStatus', form);
  const workOrderDateType = Form.useWatch('workOrderDateType', form);

  const CLOSED_SITUATIONS = [
    WorkOrderAuditSituationType.ClosedWithoutFinancial,
    WorkOrderAuditSituationType.ClosedWithLiquidValueDifferentFromFinancial,
    WorkOrderAuditSituationType.ClosedWithoutCommission,
    WorkOrderAuditSituationType.ClosedWithCommissionGreaterThanService,
  ];

  const isClosedSituation = CLOSED_SITUATIONS.includes(situationType);

  useEffect(() => {
    if (
      isClosedSituation &&
      workOrderStatus !== WorkOrderComplementStatus.Closed
    ) {
      form.setFieldsValue({
        workOrderStatus: WorkOrderComplementStatus.Closed,
      });
    }

    if (
      isClosedSituation &&
      workOrderDateType !== WorkOrderCalendarDateType.Close
    ) {
      form.setFieldsValue({
        workOrderDateType: WorkOrderCalendarDateType.Close,
      });
    }
  }, [workOrderStatus, situationType, workOrderDateType]);

  const workOrderItemOptions = [
    { label: 'Peças', value: WorkOrderAuditItemTypes.Part },
    { label: 'Serviços', value: WorkOrderAuditItemTypes.Service },
  ];

  return (
    <Form layout="vertical" form={form}>
      <Row gutter={[12, 12]}>
        <Col xs={24} sm={24} md={12} lg={6} xl={4}>
          <FloatingFormItem
            name="workOrderDateType"
            label="Filtrar por data"
            initialValue={WorkOrderCalendarDateType.Close}
          >
            <Select
              options={Object.entries(workOrderCalendarDateTypeLabels).map(
                ([value, label]) => ({
                  value,
                  label,
                  disabled:
                    value != WorkOrderCalendarDateType.Close &&
                    isClosedSituation,
                }),
              )}
            />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={24} md={12} lg={6} xl={4}>
          <FloatingFormItem
            name="rangeDate"
            label="Período"
            initialValue={[moment().subtract(6, 'months'), moment()]}
          >
            <RangePicker size="large" style={{ width: '100%' }} />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
          <FloatingFormItem name="companiesIds" label="Empresas">
            <CompaniesInfiniteSelectField
              allowClear
              mode="multiple"
              queryFilter={{ rows: 50 }}
              queryEnable
              selectAll
              activityFilter
            />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
          <FloatingFormItem
            name="situationType"
            label="Selecione uma situação"
            initialValue={WorkOrderAuditSituationType.ClosedWithoutFinancial}
          >
            <Select
              options={Object.entries(workOrderAuditSituationLabels).map(
                ([value, label]) => ({
                  value,
                  label,
                }),
              )}
            />
          </FloatingFormItem>

          {situationType ===
            WorkOrderAuditSituationType.ClosedWithoutCommission && (
            <Form.Item name="workOrderItemTypes">
              <CheckboxGroupButtons options={workOrderItemOptions} />
            </Form.Item>
          )}
        </Col>

        <Col xs={24} sm={24} md={12} lg={6} xl={4}>
          <FloatingFormItem
            name="workOrderStatus"
            label="Status O.S."
            initialValue={WorkOrderComplementStatus.Closed}
          >
            <Select
              options={Object.entries(workorderComplementLabel).map(
                ([value, label]) => ({
                  value,
                  label,
                  disabled:
                    value != WorkOrderComplementStatus.Closed &&
                    isClosedSituation,
                }),
              )}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
